export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

export enum ProductionPlanningOrigin {
  SAP = 0,
  DigitalDecoupling = 1
}

export enum SuggestionType {
  PurchaseOrder = 1,
  TransferOrder = 2,
  ReturnableAssetsPurchaseOrder = 3,
  StockReturn = 4
}
